export default "__VITE_ASSET__LoTU1mhU__"